// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__102_L","text":"SelectPayment_text__3yTfT","title":"SelectPayment_title__2Kxdl","btn":"SelectPayment_btn__2S5AV"};